import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import { motion } from "framer-motion";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLanguage } from "../context/LanguageContext";

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t, setLanguage } = useLanguage();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <div className="flex flex-col">
                <span className="text-xl font-bold text-gray-900">
                  ByteBelly
                </span>
                <span className="text-xs text-gray-500">by Solylock</span>
              </div>
            </Link>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:ml-6 md:flex md:items-center md:space-x-4">
            <Link
              to="/"
              className="px-3 py-2 rounded-md text-sm font-medium text-gray-900 hover:text-orange-500 transition-colors"
            >
              {t("home")}
            </Link>
            <Link
              to="/features"
              className="px-3 py-2 rounded-md text-sm font-medium text-gray-900 hover:text-orange-500 transition-colors"
            >
              {t("features")}
            </Link>
            <Link
              to="/pricing"
              className="px-3 py-2 rounded-md text-sm font-medium text-gray-900 hover:text-orange-500 transition-colors"
            >
              {t("pricing")}
            </Link>
            <Link
              to="/contact"
              className="px-3 py-2 rounded-md text-sm font-medium text-gray-900 hover:text-orange-500 transition-colors"
            >
              {t("contact")}
            </Link>
            <a
              href="https://foodapp.solylock.dev"
              target="_blank"
              rel="noreferrer"
              className="ml-4 px-4 py-2 rounded-md text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 transition-colors"
            >
              {t("tryDemo")}
            </a>

            <div className="ml-4">
              <LanguageSwitcher onChange={(lang) => setLanguage(lang as any)} />
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden">
            <div className="mr-4">
              <LanguageSwitcher onChange={(lang) => setLanguage(lang as any)} />
            </div>
            <button
              onClick={toggleMenu}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-orange-500 hover:bg-gray-100 focus:outline-none"
            >
              {isOpen ? (
                <FiX className="h-6 w-6" />
              ) : (
                <FiMenu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <motion.div
          className="md:hidden"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.2 }}
        >
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link
              to="/"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:text-orange-500 hover:bg-gray-50"
              onClick={toggleMenu}
            >
              {t("home")}
            </Link>
            <Link
              to="/features"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:text-orange-500 hover:bg-gray-50"
              onClick={toggleMenu}
            >
              {t("features")}
            </Link>
            <Link
              to="/pricing"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:text-orange-500 hover:bg-gray-50"
              onClick={toggleMenu}
            >
              {t("pricing")}
            </Link>
            <Link
              to="/contact"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:text-orange-500 hover:bg-gray-50"
              onClick={toggleMenu}
            >
              {t("contact")}
            </Link>
            <a
              href="https://foodapp.solylock.dev"
              target="_blank"
              rel="noreferrer"
              className="block px-3 py-2 rounded-md text-base font-medium text-white bg-orange-500 hover:bg-orange-600"
              onClick={toggleMenu}
            >
              {t("tryDemo")}
            </a>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;
